import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { ContentItemHomeThingsToDoV2 } from "scmp-app/components/content/content-item-render/variants/home-things-to-do-v2";

export const SectionTitle = styled.div`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const SectionTitleLink = styled(BaseLink)`
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const ItemsContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  gap: 16px;
  justify-content: flex-start;

  ${theme.breakpoints.only("tablet")} {
    flex-flow: row nowrap;
    gap: 20px;
  }
`;

export const Item = styled(ContentItemHomeThingsToDoV2)`
  :not(:first-of-type) {
    border-block-start: 1px #dfdfdf solid;

    padding-block-start: 16px;

    ${theme.breakpoints.only("tablet")} {
      padding-block-start: 0;
      border-block-start: none;

      padding-inline-start: 20px;
      border-inline-start: 1px #dfdfdf solid;
    }
  }
`;
